/**
 * Time formatting utilities for video analysis
 */

/**
 * Convert seconds to MM:SS format
 * @param {number} seconds - Time in seconds
 * @returns {string} Formatted time string (MM:SS or SS.Xs for < 60s)
 */
export function formatTime(seconds) {
  if (!seconds && seconds !== 0) return '0:00';
  
  const totalSeconds = Math.floor(seconds);
  const minutes = Math.floor(totalSeconds / 60);
  const secs = totalSeconds % 60;
  
  // If less than 60 seconds, show seconds with decimal
  if (minutes === 0) {
    return `${seconds.toFixed(1)}s`;
  }
  
  // Otherwise show MM:SS
  return `${minutes}:${secs.toString().padStart(2, '0')}`;
}

/**
 * Convert seconds to verbose format (e.g., "1 min 30 sec")
 * @param {number} seconds - Time in seconds
 * @returns {string} Verbose formatted time string
 */
export function formatTimeVerbose(seconds) {
  if (!seconds && seconds !== 0) return '0 seconds';
  
  const totalSeconds = Math.floor(seconds);
  const minutes = Math.floor(totalSeconds / 60);
  const secs = totalSeconds % 60;
  
  if (minutes === 0) {
    return `${seconds.toFixed(1)} seconds`;
  } else if (secs === 0) {
    return `${minutes} minute${minutes > 1 ? 's' : ''}`;
  } else {
    return `${minutes} min ${secs} sec`;
  }
}

/**
 * Format time range (e.g., "0:00-1:30")
 * @param {number} startSeconds - Start time in seconds
 * @param {number} endSeconds - End time in seconds
 * @returns {string} Formatted time range
 */
export function formatTimeRange(startSeconds, endSeconds) {
  return `${formatTime(startSeconds)}-${formatTime(endSeconds)}`;
}
